import { createContext, useContext } from 'react';

export type ToastTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export interface ToastOptions {
  title: string;
  description?: string | undefined;
  tone?: ToastTone | undefined;
  /** Milliseconds until auto-dismiss. `0` keeps the toast until it is dismissed by hand. */
  durationMs?: number | undefined;
  /**
   * One follow-up the person can take from the toast itself — typically "Desfazer" after a change
   * that applied at once. Running it also dismisses the toast.
   */
  action?: ToastAction | undefined;
}

export interface ToastAction {
  readonly label: string;
  readonly onAction: () => void;
}

export interface ToastRecord extends ToastOptions {
  readonly id: string;
  readonly tone: ToastTone;
  readonly durationMs: number;
}

export interface ToastApi {
  /** Shows a toast and returns its id so a long-running action can dismiss it later. */
  show: (options: ToastOptions) => string;
  success: (title: string, description?: string) => string;
  error: (title: string, description?: string) => string;
  dismiss: (id: string) => void;
  dismissAll: () => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const context = useContext(ToastContext);
  if (context === null) {
    throw new Error('useToast precisa estar dentro de <ToastProvider>.');
  }
  return context;
}
